import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function SimpleApp() {
  return (
    <section className="smack_simpleapp p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Similar Apps on Google Play & iOS App Store</h2>
            <p>
              As we already talked about it early, in this time and age, people
              need a message scheduling and communication tool. There are
              actually a few options on both the Google Play Store and Apple App
              Store that offer somewhat similar services. Let's have a look at a
              few other message automation apps on the two most commonly used
              app stores and see how they are different or similar to Smackback.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <div className="app_simple">
              <div className="item_app">
                <StaticImage
                  src="../../../images/case-studies/smackback/icon1.webp"
                  alt="smackback TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={50}
                  height={50}
                />
                <h4>do it later</h4>
                <p>
                  Message Automation, the app is available on Google Play. Users
                  can use this app to schedule messages, set up calls and task
                  reminders, and automate sending emails.
                </p>
              </div>
              <div className="item_app">
                <StaticImage
                  src="../../../images/case-studies/smackback/icon2.webp"
                  alt="smackback TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={50}
                  height={50}
                />
                <h4>SKEDit App</h4>
                <p>
                  Also available for download on Google Play, SKEDit is a
                  scheduling app for WhatsApp messages, text messages, sending
                  emails, and call reminders.
                </p>
              </div>
              <div className="item_app">
                <StaticImage
                  src="../../../images/case-studies/smackback/icon3.webp"
                  alt="smackback TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={50}
                  height={50}
                />
                <h4>SMS Scheduler</h4>
                <p>
                  Auto Reminder is available for download on Apple App Store. It
                  allows users to schedule text messages with customized
                  content.
                </p>
              </div>
              <div className="item_app">
                <StaticImage
                  src="../../../images/case-studies/smackback/icon4.webp"
                  alt="smackback TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={50}
                  height={50}
                />
                <h4>Schedule SMS</h4>
                <p>
                  Available on the App Store, and designed for both personal and
                  business use. It allows users to schedule text and picture
                  messages.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="p-0 text-center"
          >
            <StaticImage
              src="../../../images/case-studies/smackback/bottom-bg.webp"
              alt="smackback TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={2000}
              height={1085}
            />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <strong>
              vailable on the App Store, and designed for both personal and
              business use. It allows users to schedule text and picture
              messages.
            </strong>
            <div className="img_boxing">
              <StaticImage
                src="../../../images/case-studies/smackback/img_box.webp"
                alt="smackback TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={856}
                height={528}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SimpleApp;
